import { IUserInfo, ServerEntityType } from "../entities/common";
import { IProjectInfo } from "./ProjectsListStore";
import { ApprovalRequest, ApprovalRequestType, ApprovalStoreState, createApprovalStore } from "./ApprovalCenterStore";

export interface StageDetails {
    id: string;
    name: string;
    color: string | null;
}

export interface StageTransitionApprovalDetails {
    entityId: string;
    entityType: ServerEntityType;
    project: IProjectInfo | null;
    projectManager: IUserInfo[];
    stage: StageDetails | null;
    nextStage: StageDetails | null;
}

export type StageTransitionApprovalRequest = ApprovalRequest<StageTransitionApprovalDetails>;

const stageTransitionStore = createApprovalStore<StageTransitionApprovalDetails>(
    ApprovalRequestType.StageTransition,
    "STAGE_TRANSITION_APPROVALS"
);

export type StageTransitionApprovalState = ApprovalStoreState<StageTransitionApprovalDetails>;
export const actionCreators = stageTransitionStore.actionCreators;
export const reducer = stageTransitionStore.reducer;
